/*
DO NOT MANUALLY TRANSLATE!
Follow the instructions in the README.md to conveniently update translations.
*/

export default {
  "CookieMessage.old.link": "More information",
  "CookieMessage.old.text":
    "In order to let our webshop function well, we use cookies. View our cookie policy.",
  "CookieMessage.link": "Cookie acceptance",
  "CookieMessage.more_information": "Read more about Kramp Cookies",
  "CookieMessage.return": "Go Back",
  "CookieMessage.intro.body":
    "These cookies have been placed by Kramp as well as by third parties. Needless to say, we take good care of your privacy. If you click Accept cookies below, you are agreeing to the use of these cookies. By accepting these cookies you are ensuring that our website functions correctly. Examples of what these are used for are",
  "CookieMessage.intro.list.1": "Automatic login to My Account",
  "CookieMessage.intro.list.2":
    "Analysis of visitor behaviour to improve the website",
  "CookieMessage.intro.list.3":
    "Creation of customer profiles to allow us to provide you with personalised information and ads",
  "CookieMessage.intro.extra":
    'If you do not want to accept all cookies, you can change this in your <a>settings</a>. For more information, read our <a href="{legalLink}">privacy and cookie statement</a>',
  "CookieMessage.intro.title": "Kramp uses cookies",
  "CookieMessage.settings.body":
    "You can choose between three cookie settings. Choosing the standard setting will allow us to provide you with the best website experience.",
  "CookieMessage.settings.standard.title": "Standard (most popular):",
  "CookieMessage.settings.standard.body":
    "Cookies used for logging in, ordering, analysis, personalised information, social media and cookies from third parties.",
  "CookieMessage.settings.restricted.title": "Restricted:",
  "CookieMessage.settings.restricted.body":
    "Cookies used for logging in ordering analysis and personalised information.",
  "CookieMessage.settings.highly_restricted.title": "Highly restricted:",
  "CookieMessage.settings.highly_restricted.body":
    "You only permit the minimum number of cookies. Used solely for logging in ordering and allowing the website to function to a reasonable extent.",
  "CookieMessage.settings.options.title": "Here's what we do:",
  "CookieMessage.settings.option.1":
    "Use cookies to ensure that this website functions correctly",
  "CookieMessage.settings.option.2": "Research user behaviour",
  "CookieMessage.settings.option.3": "Track personal statistics",
  "CookieMessage.settings.option.4":
    "Display information that may be of interest",
  "CookieMessage.settings.option.5": "Use information for our ads",
  "CookieMessage.settings.option.6": "Track anonymous statistics",
  "CookieMessage.settings.option.7": "Share your personal details",
  "CookieMessage.settings.title": "Cookie settings",
  "CookiePage.url": "privacy-police-cookie",
};
